import { Observable } from 'rxjs';
/*
  "value": {
      "dt": "2019-12-19T08:25:00.000Z",
      "PVTemp": 8.6,
      "AmpTemp": 8.3,
      "Radiation": 557
  }
*/
export interface MeteostationsValue {
  dt: string;
  PVTemp: number;
  AmpTemp: number;
  Radiation: number;
}

export abstract class MeteostationsData {
  abstract getTodayData(sn: string): Observable<MeteostationsValue[]>;
}
